import React from 'react'
import { withRouter } from 'react-router-dom'

import './Styles.css'

const ActionButtons = ({ history, actionTitle, disableAction = false, onClickAction = () => ({}) }) => {
  return (
    <div className="action-buttons">
      <button className="btn danger" onClick={() => history.goBack()}>
        Voltar
      </button>
      <button
        className={`btn ${disableAction ? 'disabled' : 'success'}`}
        onClick={!disableAction ? onClickAction : () => ({})}
      >
        {actionTitle}
      </button>
    </div>
  )
}

export default withRouter(ActionButtons)
